import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({ value, setValue, handleChgIsBook }) {

    const handleChange = (event, newValue) => {
        setValue(newValue);
        handleChgIsBook(newValue, newValue + 1);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="tabs"
                    sx={{
                        minHeight: 40,

                        '& .MuiTabs-flexContainer': {
                            gap: '16px', // spacing between Booking & Enquiry
                        },

                        '& .MuiTabs-indicator': {
                            height: '8px',
                            background: 'linear-gradient(180deg,#75C4C5 0%, #0D8196 100%)',
                            borderRadius: 0,
                            clipPath: 'polygon(5% 0%, 95% 0%, 100% 100%, 0% 100%)',
                            marginTop: '10px',   // ★ GAP BETWEEN LABEL AND INDICATOR
                        }
                    }}
                >

                    {/* TAB 1 — Booking */}
                    <Tab
                        label={`Booking`}
                        {...a11yProps(0)}
                        sx={{
                            textTransform: 'none',
                            fontSize: '18px',
                            minHeight: 40,
                            paddingBottom: '14px',   // ★ consistent spacing above indicator
                            color: '#7A7A7A',
                            '&.Mui-selected': {
                                color: '#000000',
                                fontWeight: '700',
                            },
                        }}
                    />

                    {/* TAB 2 — Enquiry */}
                    <Tab
                        label={`Enquiry`}
                        {...a11yProps(1)}
                        sx={{
                            textTransform: 'none',
                            fontSize: '18px',
                            minHeight: 40,
                            paddingBottom: '14px',  // ★ SAME spacing as Booking
                            color: '#7A7A7A',
                            '&.Mui-selected': {
                                color: '#000000',
                                fontWeight: '700',
                            },
                        }}
                    />

                </Tabs>
            </Box>
        </Box>
    );
}
